var HeaderTitle = function (title) {
    var headerTitle = document.createElement("h1");
    headerTitle.appendChild(document.createTextNode(title));
    headerTitle.className = "header-title";
    return headerTitle;
};
export default HeaderTitle;
